import {z} from 'zod';
import {FIRST_LAST_NAME_REGEX} from '../../../../../shared/constants';
import {TFunction} from 'i18next';

export const createJobNameFieldSchema = (t: TFunction) =>
  z
    .string()
    .trim()
    .refine((val) => val === '' || FIRST_LAST_NAME_REGEX.test(val), {
      message: t('ai.review.jobResult.header.specialCharNotAllowed'),
    });
